import * as THREE from 'three'
import { Canvas, useFrame, useThree } from '@react-three/fiber'
import { useGLTF } from '@react-three/drei'
import { useEffect, useState, useRef } from 'react'
import styles from 'styles/components/BiancaCanvas.module.scss'
// import * as dat from 'lil-gui'
import useFaceManager from '../hooks/FaceManager'
import { SceneChild } from '../types/portfolio_types'
import * as SkeletonUtils from 'three/addons/utils/SkeletonUtils.js'

const { bianca_canvas } = styles

const PRIMARY_IDLE_ANIMATION = 'bianca_idle'

const BiancaInsideCanvas = () => {
  const bianca_model = useGLTF('/models/portfolio_forest/bianca.glb')
  const [mixer, setMixer] = useState<THREE.AnimationMixer>()
  const [, setSceneClone] = useState<THREE.Object3D<THREE.Object3DEventMap>>()
  const [sceneChild, setSceneChild] = useState<SceneChild>()

  // const [gui, setGui] = useState<dat.GUI | null>(null)
  const bianca_face_material_ref = useRef<THREE.MeshStandardMaterial | null>(null)

  useFaceManager({
    id: 'bianca_canvas',
    face_name: 'bianca',
    default_face: 'bianca neutral',
    face_material: bianca_face_material_ref.current,
    min_filter: THREE.LinearFilter,
  })

  const three = useThree()
  const { camera } = three

  useEffect(() => {
    camera.position.set(0, 1.7, 3.33)
    camera.rotation.set(-0.18, 0, 0)

    const clonedScene = SkeletonUtils.clone(bianca_model.scene)
    clonedScene.animations = bianca_model.animations

    const bianca_rig = clonedScene.children.find((child) => child.name === 'bianca_rig')!
    const mixer = new THREE.AnimationMixer(clonedScene)

    setSceneChild({
      object: bianca_rig,
      element: <primitive object={bianca_rig} key={bianca_rig.id} />,
    })
    setMixer(mixer)
    setSceneClone(clonedScene)

    const idle_animation_clip = clonedScene.animations.find((clip) => clip.name === PRIMARY_IDLE_ANIMATION)!
    mixer.clipAction(idle_animation_clip).play()

    bianca_face_material_ref.current = bianca_model.materials.bianca_face as THREE.MeshStandardMaterial

    // const newGui = new dat.GUI({ closeFolders: false })
    // const guiCameraFolder = newGui.addFolder('Camera')
    // guiCameraFolder.add(camera.position, 'x').min(-60).max(60).step(0.01).name('positionX').listen()
    // guiCameraFolder.add(camera.rotation, 'x').min(-60).max(60).step(0.01).name('rotationX').listen()
    // guiCameraFolder.add(camera.position, 'y').min(-60).max(60).step(0.01).name('positionY').listen()
    // guiCameraFolder.add(camera.position, 'z').min(-60).max(60).step(0.01).name('positionZ').listen()
    // setGui(newGui)
  }, [camera, bianca_model])

  useFrame((_state, delta) => {
    if (!sceneChild || !mixer) return
    mixer.update(delta)
  })

  return (
    <>
      <directionalLight
        castShadow={false}
        position={[4, 4, 1]}
        intensity={2.5}
        shadow-mapSize={[1024, 1024]}
        shadow-camera-near={1}
        shadow-camera-far={10}
        shadow-camera-top={10}
        shadow-camera-right={10}
        shadow-camera-bottom={-10}
        shadow-camera-left={-10}
      />
      <ambientLight intensity={1.2} />

      {sceneChild?.element}
    </>
  )
}

const BiancaCanvas = () => {
  return (
    <Canvas
      className={bianca_canvas}
      gl={{ toneMapping: THREE.LinearToneMapping, antialias: true }}
      camera={{
        fov: 45,
        near: 0.1,
        far: 8,
        position: [0, 0, 0],
      }}
    >
      <BiancaInsideCanvas />
    </Canvas>
  )
}

export default BiancaCanvas

useGLTF.preload('/models/portfolio_forest/bianca.glb')
